import { render, staticRenderFns } from "./playImg.vue?vue&type=template&id=1440444c&scoped=true&"
import script from "./playImg.vue?vue&type=script&lang=js&"
export * from "./playImg.vue?vue&type=script&lang=js&"
import style0 from "./playImg.vue?vue&type=style&index=0&id=1440444c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1440444c",
  null
  
)

export default component.exports